class DZModelProcess{
    /**
     * 用户ID
     */
    userId;

    /**
     * 审核结果：1-审核未通过，0-审核通过
     */
    result;

    /**
     * 不通过原因
     */
    content;
}
export default DZModelProcess